export const getClaimCodeLink = (couponSlug: string): string => `{{'${couponSlug}'|coupon}}`;

const CLAIM_CODE_LINK_REGEX = /\{\{'([^']+)'\|coupon\}\}/;

export const parseClaimCodeLink = (link: string | null | undefined): string | null =>
  link ? (CLAIM_CODE_LINK_REGEX.exec(link)?.[1] ?? null) : null;
